namespace Matrix.Workflow {
    export class ClientFunctionColumns {
        static columnsKey = 'Workflow.ClientFunction';
    }
}
